const ST = new Setter()
const LT = new Listener()
const OB = new Observer()


ST.setElement({
    instruction: ':first:#PHContent',
    set: el => {
        const preContent = document.getElementById('PHpreContent')
        if(preContent) {
            console.log(preContent.dataset.nosearch);
            const title = preContent.querySelector('h1')
            const desc = preContent.querySelector('p')
            const content = `
            <p>${preContent.dataset.subtitle || ""}</p>
            <div class="BGedDiv">
                <h1> ${title?.innerText || ''} </h1>
            </div>
            ${preContent.dataset.nosearch == 'true' ?`
            <p>${desc?.innerText || ''}</p>
            `:`
            <form action="/search" method="get" role="search">
            <input type="search" name="q" class="SearchInp" placeholder="Search" value="${preContent.dataset.searchterm || ''}">
            <button type="submit" class="SearchBtn"> <img class="search-icon" alt="search icon"> </button>
            </form>
            `}`
            el.innerHTML = content 
            preContent.remove();
        }
    }
})

ST.setElement({
    instruction: ':all:.Modal',
    set: (el) => {
        const openBtn = ST.getElement(":all:."+el.dataset.for+'Open')
        const zoomBtn = el.querySelector("."+el.dataset.for+'Zoom')
        const wrapper = el.querySelector('.'+el.dataset.for)
        const modalcontent = wrapper.querySelector('.ModalContent') 
        LT.listens([{
            instruction: ':click',
            element: [zoomBtn],
            callback: () => { 
                if(modalcontent.classList.contains('Active')) {
                    modalcontent.classList.remove('Active')
                    zoomBtn.querySelector('img')?.classList.replace("zoomout-icon", "zoomin-icon");
                }
                else {
                    modalcontent.classList.add('Active')
                    zoomBtn.querySelector('img')?.classList.replace("zoomin-icon", "zoomout-icon");
                }
            }
            },{
            instruction: ':click',
            element: openBtn,
            callback: (e) => {
                if(el.dataset.for == 'zoomIMG') { 
                    const img = document.createElement('img')
                    let src = e.target.dataset.zoom
                    if(window.innerWidth > 1200 ) src = e.target.dataset.master
                    if(window.innerWidth < 700) src = e.target.dataset.enlarge
                    img.src = src
                    img.alt = "product zoom image" 
                    img.draggable = false
                    modalcontent.innerHTML = img.outerHTML 
                }
                wrapper.classList.add(el.dataset.orient+'Active')
                el.classList.add('ModalActive')
            }},{
            instruction: ':click',
            element: [el],
            callback: (e) => {
                e.stopPropagation() 
                if(e.target === e.currentTarget || e.target.dataset.close) {
                    wrapper.classList.remove(el.dataset.orient+'Active')
                    el.classList.remove('ModalActive')
                } 
            }
        }]) 
    }
})

ST.setElement({
    instruction: ':all:.TabList',
    set: (el) => {
        let last = undefined
        let latest = [null, null]
        ST.setElements([{
            instruction: 'tablink:all:.TabListLinks li',
            parent: el,
            set: link => {
                LT.listen({
                    instruction: ':click',
                    element: [link],
                    callback: e => {
                        last = [...latest]
                        latest[0] = e.target
                        latest[1] = el.querySelector('.TabListItems .'+e.target.dataset.for)
                        latest.forEach(lt => lt?.classList.add('Active'))
                        if(last) last.forEach(la => la?.classList.remove('Active'))
                    }
                })
            }},{
            instruction: 'tablink:_first',
            set: el => el.click()
        }]) 
    }
})

let timerr = null
LT.listens([{
    instruction: 'notif:mouseenter:all:.NotifIcon',
    callback: () => {
        ST.setElement({
            instruction: "notif:first:.Notif",
            set: el => el.classList.add('Active')
        })
    }
},{
    instruction: 'notif:mouseleave:get',
    callback: () => {
        ST.setElement({
            instruction: "notif:_first:",
            set: el => {
                if (timerr) clearTimeout(timerr) 
                timerr = setTimeout(() => {
                    el.classList.remove('Active')
                }, 2000);
            }
        })
    }
},{
    instruction: 'notif:click:get',
    callback: () => {
        ST.setElement({
            instruction: "notif:_first:",
            set: el => {
                if(el.classList.contains('Active')) el.classList.remove('Active')
                else el.classList.add('Active')
            }
        })
    }
}])

ST.setElement({
    instruction: ':first:body',
    set: el => {
        console.log('body '+document.readyState);
    }
})

 ST.setElement({
    instruction: ':all:.readMore',
    set: el => {
        el.style.height = 0
        let active = false
        const readmore =  document.createElement('span')
        readmore.innerText = '...read more'
        readmore.classList.add('readMoreBtn')
        readmore.addEventListener('click', ()=> {
            if(active) {
                readmore.innerText = '...read More'
                el.style.height = 0
                active = false
            } else {
                readmore.innerText = 'read Less'
                el.style.height = 'max-content'
                active = true
            }
        })
        el.parentNode.append(readmore)
    }
 })

 const headnav = document.querySelector('.HeadNavSticky')
 OB.observe({
    instructions: ':intersection:one:.HeadNav',
    callback: entry => {
        if(entry.isIntersecting) { 
            headnav.classList.remove('Active')
        } else {
            headnav.classList.add('Active')  
        }
    } 
 })

// barba.init({
//   transition: [
//     {
//       name: "opacity-transition",
//       leave(data) {
//         console.log(data);
//         return gsap.timeline().fromTo(
//           ".loading-bg",
//           {
//             y: "100%",
//           },
//           {
//             y: 0,
//           }
//         );
//       },
//       enter(data) {
//         console.log(data);
//         return gsap.timeline().fromTo(
//           ".loading-bg",
//           {
//             y: 0,
//           },
//           {
//             y: "100%",
//             duration: 2,
//           }
//         );
//       },
//     },
//   ],
// })
